// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Random = require("bs-platform/lib/js/random.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var RList$Rationale = require("rationale/src/RList.js");
var Function$Rationale = require("rationale/src/Function.js");

function length_diff(a, b) {
  return List.length(a) - List.length(b) | 0;
}

function get_position(p) {
  var partial_arg = Function$Rationale.Infix[/* ||> */1];
  return (function (param) {
      return partial_arg((function (__x) {
                    return List.nth(__x, p[/* y */1]);
                  }), (function (__x) {
                    return List.nth(__x, p[/* x */0]);
                  }), param);
    });
}

function shift_zeroes(xs) {
  var match = RList$Rationale.partition((function (x) {
          return x !== 0;
        }), xs);
  return Pervasives.$at(match[1], match[0]);
}

function find_zeroes(param) {
  return RList$Rationale.fold_lefti((function (acc, y) {
                return (function (param) {
                    return RList$Rationale.fold_lefti((function (acc$prime, x, tile) {
                                  var match = tile === 0;
                                  if (match) {
                                    return Pervasives.$at(acc$prime, /* :: */[
                                                /* record */[
                                                  /* x */x,
                                                  /* y */y
                                                ],
                                                /* [] */0
                                              ]);
                                  } else {
                                    return acc$prime;
                                  }
                                }), acc, param);
                  });
              }), /* [] */0, param);
}

function get_columns(xs) {
  return List.mapi((function (x) {
                return (function (param) {
                    return List.mapi((function (y, param) {
                                  return get_position(/* record */[
                                                /* x */x,
                                                /* y */y
                                              ])(xs);
                                }), param);
                  });
              }), xs);
}

function merge_row_right(xs) {
  var _index = 0;
  var _ys = shift_zeroes(xs);
  while(true) {
    var ys = _ys;
    var index = _index;
    if (ys) {
      var match = ys[1];
      if (match) {
        var match$1 = match[1];
        if (match$1) {
          var match$2 = match$1[1];
          if (match$2 && !match$2[1]) {
            var d = match$2[0];
            var c = match$1[0];
            var b = match[0];
            var a = ys[0];
            switch (index) {
              case 0 : 
                  if (c === d) {
                    _ys = /* :: */[
                      0,
                      /* :: */[
                        a,
                        /* :: */[
                          b,
                          /* :: */[
                            (c << 1),
                            /* [] */0
                          ]
                        ]
                      ]
                    ];
                    _index = 1;
                    continue ;
                  } else {
                    return ys;
                  }
              case 1 : 
                  if (b === c) {
                    _ys = /* :: */[
                      0,
                      /* :: */[
                        a,
                        /* :: */[
                          (b << 1),
                          /* :: */[
                            d,
                            /* [] */0
                          ]
                        ]
                      ]
                    ];
                    _index = 2;
                    continue ;
                  } else {
                    return ys;
                  }
              case 2 : 
                  if (a === b) {
                    _ys = /* :: */[
                      0,
                      /* :: */[
                        (a << 1),
                        /* :: */[
                          c,
                          /* :: */[
                            d,
                            /* [] */0
                          ]
                        ]
                      ]
                    ];
                    _index = 3;
                    continue ;
                  } else {
                    return ys;
                  }
              default:
                return ys;
            }
          } else {
            return ys;
          }
        } else {
          return ys;
        }
      } else {
        return ys;
      }
    } else {
      return ys;
    }
  };
}

var partial_arg = Function$Rationale.Infix[/* ||> */1];

function partial_arg$1(param) {
  return partial_arg(List.rev, merge_row_right, param);
}

var partial_arg$2 = Function$Rationale.Infix[/* ||> */1];

function merge_row_left(param) {
  return partial_arg$2(partial_arg$1, List.rev, param);
}

function merge_grid_right(param) {
  return List.map(merge_row_right, param);
}

function merge_grid_left(param) {
  return List.map(merge_row_left, param);
}

function merge(direction) {
  switch (direction) {
    case 0 : 
        return merge_grid_left;
    case 1 : 
        return merge_grid_right;
    case 2 : 
        var partial_arg = Function$Rationale.Infix[/* ||> */1];
        var partial_arg$1 = function (param) {
          return partial_arg(get_columns, merge_grid_left, param);
        };
        var partial_arg$2 = Function$Rationale.Infix[/* ||> */1];
        return (function (param) {
            return partial_arg$2(partial_arg$1, get_columns, param);
          });
    case 3 : 
        var partial_arg$3 = Function$Rationale.Infix[/* ||> */1];
        var partial_arg$4 = function (param) {
          return partial_arg$3(get_columns, merge_grid_right, param);
        };
        var partial_arg$5 = Function$Rationale.Infix[/* ||> */1];
        return (function (param) {
            return partial_arg$5(partial_arg$4, get_columns, param);
          });
    
  }
}

function update_grid(value, zero, grid) {
  var old_row = List.nth(grid, zero[/* y */1]);
  var new_row = RList$Rationale.update(value, zero[/* x */0], old_row);
  return RList$Rationale.update(new_row, zero[/* y */1], grid);
}

function fill_random_empty_tile(random_seed) {
  Random.init(random_seed);
  return (function (grid) {
      var empty_tiles = find_zeroes(grid);
      var position;
      if (empty_tiles) {
        if (empty_tiles[1]) {
          var i = Random.$$int(List.length(empty_tiles));
          position = i !== 0 ? List.nth(empty_tiles, i - 1 | 0) : List.hd(empty_tiles);
        } else {
          position = empty_tiles[0];
        }
      } else {
        position = undefined;
      }
      if (position !== undefined) {
        var match = Random.$$int(100) < 90;
        var new_tile_value = match ? 2 : 4;
        return update_grid(new_tile_value, position, grid);
      }
      
    });
}

function get_score(param) {
  return RList$Rationale.fold_lefti((function (acc, param) {
                return (function (param) {
                    return RList$Rationale.fold_lefti((function (acc$prime, param, tile) {
                                  return acc$prime + tile | 0;
                                }), acc, param);
                  });
              }), 0, param);
}

function direction_to_string(direction) {
  switch (direction) {
    case 0 : 
        return "left";
    case 1 : 
        return "right";
    case 2 : 
        return "up";
    case 3 : 
        return "down";
    
  }
}

function grid_to_matrix(grid) {
  var matrix = $$Array.make_matrix(4, 4, 0);
  List.iteri((function (y) {
          return (function (param) {
              return List.iteri((function (x, tile) {
                            return Caml_array.caml_array_set(Caml_array.caml_array_get(matrix, y), x, tile);
                          }), param);
            });
        }), grid);
  return matrix;
}

function get_valid_moves(grid) {
  return List.filter((function (x) {
                  return Caml_obj.caml_notequal(x[/* grid */1], grid);
                }))(List.map((function (direction) {
                    var grid$prime = merge(direction)(grid);
                    var zeroes = List.length(find_zeroes(grid$prime));
                    return /* record */[
                            /* direction */direction,
                            /* grid */grid$prime,
                            /* score */get_score(grid$prime),
                            /* zeroes */zeroes
                          ];
                  }), /* :: */[
                  /* Right */1,
                  /* :: */[
                    /* Up */2,
                    /* :: */[
                      /* Down */3,
                      /* :: */[
                        /* Left */0,
                        /* [] */0
                      ]
                    ]
                  ]
                ]));
}

var partial_arg$3 = Function$Rationale.Infix[/* ||> */1];

function partial_arg$4(param) {
  return partial_arg$3(get_valid_moves, (function (param) {
                return List.sort((function (a, b) {
                              return b[/* zeroes */3] - a[/* zeroes */3] | 0;
                            }), param);
              }), param);
}

var partial_arg$5 = Function$Rationale.Infix[/* ||> */1];

function partial_arg$6(param) {
  return partial_arg$5(partial_arg$4, (function (param) {
                return List.sort((function (a, b) {
                              return b[/* score */2] - a[/* score */2] | 0;
                            }), param);
              }), param);
}

var partial_arg$7 = Function$Rationale.Infix[/* ||> */1];

function best_move(param) {
  return partial_arg$7(partial_arg$6, (function (moves) {
                var match = List.length(moves);
                if (match !== 0) {
                  return List.hd(moves)[/* direction */0];
                }
                
              }), param);
}

var partial_arg$8 = Function$Rationale.Infix[/* ||> */1];

function partial_arg$9(param) {
  return partial_arg$8(get_valid_moves, List.length, param);
}

var partial_arg$10 = Function$Rationale.Infix[/* ||> */1];

function is_mergeable(param) {
  return partial_arg$10(partial_arg$9, (function (len) {
                return len !== 0;
              }), param);
}

exports.length_diff = length_diff;
exports.get_position = get_position;
exports.shift_zeroes = shift_zeroes;
exports.find_zeroes = find_zeroes;
exports.get_columns = get_columns;
exports.merge_row_right = merge_row_right;
exports.merge_row_left = merge_row_left;
exports.merge_grid_right = merge_grid_right;
exports.merge_grid_left = merge_grid_left;
exports.merge = merge;
exports.update_grid = update_grid;
exports.fill_random_empty_tile = fill_random_empty_tile;
exports.get_score = get_score;
exports.direction_to_string = direction_to_string;
exports.grid_to_matrix = grid_to_matrix;
exports.get_valid_moves = get_valid_moves;
exports.best_move = best_move;
exports.is_mergeable = is_mergeable;
/* RList-Rationale Not a pure module */
